import React from 'react';
import PropTypes from 'prop-types';

import './flexboxgrid.scss';

const SPACES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const OFFSETS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
const BREAK_POINTS = ['xs', 'sm', 'md', 'lg'];

const widesToClassName = wides =>
  wides
    .map(({ breakPoint = 'xs', wide }) =>
      wide ? `col-${breakPoint}-${wide}` : `col-${breakPoint}`,
    )
    .join(' ');

const offsetsToClassName = offsets =>
  offsets.map(({ breakPoint = 'xs', offset }) => `col-${breakPoint}-offset-${offset}`).join(' ');

const Column = ({ children, wides, offsets, alignSelf }) => {
  return (
    <div
      className={[
        widesToClassName(wides),
        offsets && offsetsToClassName(offsets),
        alignSelf && `align-self-${alignSelf}`,
      ]
        .filter(className => className)
        .join(' ')}
    >
      {children}
    </div>
  );
};

Column.propTypes = {
  children: PropTypes.node.isRequired,
  wides: PropTypes.arrayOf(
    PropTypes.exact({
      breakPoint: PropTypes.oneOf([...BREAK_POINTS, undefined]),
      wide: PropTypes.oneOf([...SPACES, undefined]),
    }),
  ),
  offsets: PropTypes.arrayOf(
    PropTypes.exact({
      breakPoint: PropTypes.oneOf(BREAK_POINTS),
      offset: PropTypes.oneOf(OFFSETS),
    }),
  ),
  alignSelf: PropTypes.oneOf(['start', 'center', 'end', 'stretch']),
};

Column.defaultProps = {
  offsets: null,
  wides: [{ breakPoint: 'xs' }],
  alignSelf: null,
};

export default Column;
